import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-generic-frame',
  templateUrl: './dialog-generic-frame.component.html',
  styleUrls: ['./dialog-generic-frame.component.css']
})

export class DialogGenericFrame {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}
